import React, { useState, useEffect } from 'react';
import { useDropzone } from 'react-dropzone';
import Form from 'deltoid/core/Form';
import { Caption } from 'deltoid/core/Blocks/Typography';

const Uploader = ({
  onFileDropAccepted,
  onFileDropRejected,
  handleRemoveFile: handleRemoveFileProp,
  allowedFileExtensions,
  maxFileSizeInMB,
  label='Upload',
}) => {
  const [file, setFile] = useState(null);

  const onDropAccepted = (acceptedFiles, event) => {
    console.log('Accepted File: ', acceptedFiles);
    setFile(acceptedFiles[0]);
    onFileDropAccepted(acceptedFiles);
  };
  const onDropRejected = (rejectedFiles, event) => {
    console.log('Rejected File ', rejectedFiles[0].file, 'File Error: ', rejectedFiles[0].errors);
    setFile(null);
    onFileDropRejected(rejectedFiles);
  };

  const handleRemoveFile = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setFile(null);
    handleRemoveFileProp();
  };

  const { getRootProps, open, getInputProps } = useDropzone({
    onDropAccepted,
    onDropRejected,
    accept: allowedFileExtensions,
    maxSize: maxFileSizeInMB * 1024 * 1024,
  });
  return (
    <div
      {...getRootProps()}
      onClick={open}
      className='d-flex'
    >
      <input {...getInputProps()} />
      {
        file && (
          <Caption className='mr-3 text-truncate max-width-50'>{file.name}</Caption>
        )
      }
      {
        !file
        ? (
          <Form.Button variant='underlined' type='button' className='p-0 inline-block'>
            <Caption>{label}</Caption>
          </Form.Button>
        ) : (
          <Form.Button variant='underlined' type='button' className='p-0 inline-block' onClick={handleRemoveFile}>
            <Caption>Remove</Caption>
          </Form.Button>
        )}
    </div>
  )
};

export default Uploader;
